import { PEQuestionnaire } from '../../../../../lib/Questionnaires'
import {
  RadioGroupInput,
  CheckboxInput,
  TextInput
} from '../../../../shared/FormBuilder'

function Extremities () {
  return (
    <div className='form-section'>
      <div className='row'>
        <div className='col-xs-offset-1 col-xs-4 nh-sub-head'>Normal</div>
        <div className='col-xs-6 nh-sub-head'>Abnormal</div>
      </div>
      <div className='row'>
        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.extremitiesClubbing.name}
            options={[
              {
                label: 'No Clubbing',
                value: 'No Clubbing'
              },
              {
                label: 'Clubbing',
                value: 'Clubbing'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.extremitiesTender.name}
            options={[
              {
                label: 'Non-Tender',
                value: 'Non-Tender'
              },
              {
                label: 'Tender',
                value: 'Tender'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.extremitiesROM.name}
            options={[
              {
                label: 'Full ROM',
                value: 'Full ROM'
              },
              {
                label: 'Limited ROM',
                value: 'Limited ROM'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.extremitiesEdema.name}
            options={[
              {
                label: 'No Edema',
                value: 'No Edema'
              },
              {
                label: 'Edema',
                value: 'Edema'
              }
            ]}
          />
        </div>

        <div
          className='col-xs-offset-1 col-xs-10'
          style={{ marginBottom: '13px' }}
        >
          <RadioGroupInput
            name={PEQuestionnaire.extremitiesCyanosis.name}
            options={[
              {
                label: 'No Cyanosis',
                value: 'No Cyanosis'
              },
              {
                label: 'Cyanosis',
                value: 'Cyanosis'
              }
            ]}
          />
        </div>
        <div className='col-xs-offset-1 col-xs-11 margin-top'>
          <CheckboxInput {...PEQuestionnaire.extremitiesOther} />
        </div>
      </div>

      <div className='row'>
        <div className='col-xs-12'>
          <TextInput {...PEQuestionnaire.extremitiesOtherText} />
        </div>
      </div>
    </div>
  )
}

export default Extremities
